/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {findConversionTypeDescription} from './custom-event-commons';
import {AppSharedModule} from '../../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule],
  selector: 'adn-custom-event-conversion-type-description',
  template: `@if (description) { <span>{{ description }}</span> }`
})
export class CustomEventConversionTypeDescriptionComponent implements OnChanges {
  @Input() conversionType: string | null;
  description = '';

  ngOnChanges(): void {
    this.description = findConversionTypeDescription(this.conversionType);
  }
}
